// frontend/src/config/uiFlags.ts
// Flags temporales de UI. Los KPIs de estas páginas se ocultan por falta de
// ciertos datos; reactivar una página = poner su valor a true.
export const PAGE_KPIS = {
  advanced: false,   // Vista avanzada (semanal + mensual)
  plan: false,       // Plan de Producción
  inventory: false,  // Inventario
  production: false, // Producción (diaria)
  purchase: false,   // Pedidos Compra
  sales: false,      // Pedidos Venta
} as const;
